module.exports = __webpack_public_path__ + "brandon_reg_it-webfont.31a076336ccba0742f06.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_reg_it-webfont.woff
// module id = 949
// module chunks = 7